let initialState = {
  loans: []
};

export function loans(state = initialState, action) {
  switch (action.type) {
    case "GET_LOAN":
      return state;
    case "LOAN_LOADED":
      return action.payload;
    case "LOAN_FAILED_TO_LOAD":
      return action.payload;
    case "CLEAR_LOAN":
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loans.js